import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const NotesFieldContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.notesFieldContainer, className)}
    data-testid="notes-field-container"
  />
));

NotesFieldContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default NotesFieldContainer;
